<script setup lang="ts">
</script>

<template>
  <div
    class="w-max h-full relative overflow-hidden"
  >
    <img
      class="w-auto h-full object-cover"
      src="@/assets/images/banners-s2/dropee-presale-banner-s2.webp"
    >
    <div class="inset-0 absolute rounded-[18px] overflow-hidden">
      <span class="relative block h-full w-full"><i class="shine" /></span>
    </div>
  </div>
</template>

<style scoped>

</style>
